/* global fetch, Headers */

export default function(path, data) {
  console.log('post', path, data)
  return fetch(path, {
    method: 'POST',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
    body: JSON.stringify(data),
  }).then(r => r.json())
}



// WEBPACK FOOTER //
// ./utils/post.js